<template>
  <Div class="score">
    <!-- <div class="test_paper_inner">
      <div class="test" v-for="(item,index) in test" :key="index">
        <div class="test_title flex">
          <div class="index">{{index+1}}</div>
          {{item.question}}
        </div>
        <div class="test_option">
          <div><span>{{item.correct_answer}}</span>:
            <template v-for='(text) in item.answer_list'>
              <template v-if='text.answer_item==item.correct_answer'>{{text.answer_text}}</template>
            </template>
          </div>
        </div>
      </div>
    </div>-->
    <div class="test_bottom">
      <div class="basic flex">
        <div>
          {{this.userName}}已於{{today}}通過「{{courseName}}」測驗，
          特此回簽，證明本次測驗為本人親自測驗。
        </div>
      </div>
      <div class="test_declare">
        <div class="flex" v-for="(item,index) in declare" :key="index">
          <div class="box"></div>
          {{item.text}}
        </div>
      </div>
      <div class="test_sign flex">
        <div class="sign">簽名：</div>
        <div class="time">日期：</div>
      </div>
    </div>
  </Div>
</template>
<style lang="scss">
.score {
  max-width: 1024px;
  text-align: left;
  margin: 10px auto;
  .test_bottom {
    margin: 30px 20px;

    .test_declare {
      margin: 10px 0;
      > div {
        margin: 5px 0;
        align-items: center;
        .box {
          margin-right: 10px;
          width: 20px;
          height: 20px;
          border: 1px solid #ccc;
          border-radius: 3px;
        }
      }
    }
    .test_sign {
      margin-top: 50px;
      justify-content: flex-end;
      .sign {
        width: 200px;
      }
      .time {
        width: 200px;
      }
    }
  }
  .test_paper_inner {
    padding: 20px 30px;
    border: 1px solid #ccc;
    border-radius: 5px;
    .test {
      margin: 20px 0;
      .test_title {
        margin: 5px 0;
        .index {
          margin: 0 10px 0 0;
          font-weight: bold;
          color: var(--mainColor);
        }
      }
      .test_option {
        border-top: 1px dashed #ccc;
        padding-top: 5px;
        .answer_index {
          font-weight: bold;
        }
      }
    }
  }
  .test_paper_btn {
    width: 200px;
    margin: 20px auto;
  }
}
</style>
<script>
import * as moment from "moment";
export default {
  name: "score",
  data() {
    return {
      test: [],
      declare: [
        {
          text: "是否已閱讀承攬商安全衛生環保承諾書並了解其規範並且確實遵守。"
        },
        { text: "是否了解廠內資安管制項目並且確實遵守。" }
      ]
    };
  },
  computed: {
    courseName() {
      return this.$route.query.courseName;
    },
    userID() {
      return this.$route.query.userID;
    },
    courseID() {
      return this.$route.query.courseID;
    },
    userName() {
      return this.$route.query.userName;
    },
    today() {
      return moment().format("YYYY-MM-DD");
    }
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$http.api.vendor.print(this.userID, this.courseID).then(res => {
        this.test = res.data;
      });
    }
  }
};
</script>